import { useCallback } from 'react';

import { Trash } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import { ControlledConfirmationPopover } from '@/components/ConfirmationPopover';
import { useAppAlert } from '@Components/AppAlert';
import { getInfo } from '@Components/Grid/components/Table/formatters';
import { useGrid } from '@Components/Grid/context';

export default function DeleteEntityFormatter({ info }) {
  const { row } = getInfo(info)
  const { definitions: { entityName }, events: { handleDeleteEntry } } = useGrid()
  const { handleSuccess } = useAppAlert()

  const description = row.first_name && row.last_name ? `${row.first_name} ${row.last_name}` : `${row.email}`

  const handleSubmit = useCallback(async () => {
    await handleDeleteEntry(row)
    handleSuccess(`${entityName} deleted!`)
  }, [row, handleDeleteEntry, handleSuccess, entityName])

  return <>
    <ControlledConfirmationPopover
      target={<DefaultTooltip content='Delete' side='left'><Trash size={16} /></DefaultTooltip>}
      title={<span>Delete {entityName.toLowerCase()} <i>{`[#${row.id}] ${description}`}</i></span>}
      onSubmit={handleSubmit}
    >
      <strong className='mb-1'>Are you sure you want do this?</strong>
    </ControlledConfirmationPopover>
  </>
}
